var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback } from 'react';
import { translate, useToastService } from '@lucidlink/uicore';
import { useOnFilespaceUpgrade, } from '@lucidlink/workspacemanagement';
const createToastId = (filespaceId) => `filespace-upgrading-${filespaceId}`;
const UPGRADE_NOTIFICATION = 'upgradeNotification';
export const useFilespaceUpgradeNotifier = ({ currentMember, filespaceList, workspaceId, }) => {
    _react_refresh_temp_1();
    const { addToast, removeToast } = useToastService();
    const isOwner = Boolean(currentMember?.isOwner);
    const onStartUpgrade = useCallback(({ filespace }) => {
        addToast({
            'data-testid': 'filespace-upgrading',
            id: createToastId(filespace.id),
            kind: 'informative',
            dismissTempo: 'never',
            hasCloseButton: true,
            content: {
                label: translate('{{name}} is being upgraded', {
                    name: filespace.name,
                }),
                message: translate('You can’t access its files or make changes to it while the upgrade is ongoing.'),
            },
        });
    }, [addToast]);
    const onFinishUpgrade = useCallback(({ isUpgradeSuccessful, newFilespace, oldFilespace, }) => {
        const label = isUpgradeSuccessful
            ? translate('{{name}} has been upgraded', {
                name: oldFilespace.name,
            })
            : translate('Upgrade for {{name}} has been stopped', {
                name: oldFilespace.name,
            });
        const testId = isUpgradeSuccessful
            ? `filespace-upgraded`
            : `filespace-upgrade-aborted`;
        removeToast(createToastId(oldFilespace.id));
        addToast({
            'data-testid': testId,
            id: `upgraded-filespace-${newFilespace.id}`,
            kind: 'informative',
            hasCloseButton: true,
            dismissTempo: 'slow',
            content: {
                label,
                message: translate('You can now access its files.'),
            },
        });
    }, [addToast, removeToast]);
    // The owner is the one initiating the upgrade so they don't need additional notifications
    useOnFilespaceUpgrade({
        filespaceList,
        onFinishUpgrade: isOwner ? null : onFinishUpgrade,
        onStartUpgrade: isOwner ? null : onStartUpgrade,
        localStorageKey: currentMember?.id
            ? `${UPGRADE_NOTIFICATION}-${workspaceId}-${currentMember.id}`
            : undefined,
    });
};
_react_refresh_temp_1(useFilespaceUpgradeNotifier, "ixfGJCtm4rT+vpFA2Kze4bYZM50=", false, () => [useToastService, 
    // The owner is the one initiating the upgrade so they don't need additional notifications
    useOnFilespaceUpgrade]);
